
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/raffles/[id]",
      function () {
        return require("private-next-pages/raffles/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/raffles/[id]"])
      });
    }
  